document.addEventListener('DOMContentLoaded', function() {
  var newsletterPopup = document.getElementById('newsletter-popup');
  var closeButton = document.getElementById('newsletter-popup-close');

  if (newsletterPopup && closeButton) {
    closeButton.addEventListener('click', function() {
      newsletterPopup.style.display = 'none';
    });

    // Check if the popup should be displayed (e.g., only once per session)
    var popupShown = sessionStorage.getItem('newsletterPopupShown');
    if (!popupShown) {
      newsletterPopup.style.display = 'block';
      sessionStorage.setItem('newsletterPopupShown', 'true');
    }
  }
});
